/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { Fragment, useState, useEffect } from '@wordpress/element';
import { ResizableBox, Disabled, Button, Placeholder, TextControl, Icon } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

import Inspector from './inspector';
// import { updateBlockStyle } from './inline-styles';

const Edit = ( props ) => {
	const {
		attributes,
		isSelected,
		setAttributes,
		toggleSelection,
		className,
	} = props;
	const { location, height, pinned, width, zoom, language, blockClientId } = attributes;
	const [ { locationState }, setState ] = useState( {
		locationState: '',
	} );

	useEffect( () => {
		// updateBlockStyle( {}, props );
		setState( {
			locationState: location,
		} );
	}, [] );

	const wrapperClasses = classnames(
		className,
		`gutenify-block-map-wrapper`,
		`gutenify-section-${ blockClientId }`,
	);

	return <div className={ wrapperClasses }>
		{ isSelected && <Inspector { ...props } /> }
		{ ! pinned && <Fragment>
			<Placeholder icon={ <Icon icon="location-alt" /> }
				label={ __( 'Map', 'coblocks' ) }
				instructions={ __(
					'Enter a location or address to drop a pin on a Google map.'
				) }>
				<div className="gutenify-map-search-form-wrapper">
					<TextControl onChange={ ( val ) => {
						setState( { locationState: val } );
					} } value={ locationState } />
					<Button onClick={ () => {
						if ( '' !== locationState ) {
							setAttributes( {
								location: locationState,
								pinned: true,
							} );
						}
					} } disabled={ '' === locationState } isSecondary>Save</Button>
				</div>
			</Placeholder>
		</Fragment> }
		{ !! pinned && <ResizableBox
			showHandle={ isSelected }
			size={ {
				height,
				width: '100%',
			} }
			minHeight="200"
			enable={ {
				bottom: true,
				bottomLeft: false,
				bottomRight: false,
				left: false,
				right: false,
				top: false,
				topLeft: false,
				topRight: false,
			} }
			onResizeStop={ ( event, direction, elt, delta ) => {
				setAttributes( {
					height: parseInt( height + delta.height, 10 ),
					width: parseInt( width + delta.width, 10 ),
				} );
				toggleSelection( true );
			} }
			onResizeStart={ () => {
				toggleSelection( false );
			} }
		>
			<Disabled>
				<iframe title="Google Map" frameBorder={ 0 } src={ `https://www.google.com/maps?q=${ encodeURIComponent( location ) }&output=embed&hl=${ language }&z=${ zoom }` } style={ { minHeight: `${ height }px`, width: `100%` } }></iframe>
			</Disabled>
		</ResizableBox> }
	</div>;
};

export default Edit;
